import {
  API_END_POINT,
  axiosInstance,
  ENTITY_MANAGER_END_POINTS,
} from '@app-store'

export const fetchTaskStatus = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.WORKFLOW}/${ENTITY_MANAGER_END_POINTS.TASKS}/states`
  )
}
